<template>
      <div id="app" class="d-flex flex-column h-100">
          <o-app-drawer
                  :items="items"
                  :admin_items="admin_items" >

                  <template v-slot:brand>
                    <div><div><strong>Independent Pods</strong> - Job Management</div></div>
                  </template>
          ></o-app-drawer>

          <o-app-content></o-app-content>

          <o-app-footer version="0.52.0" year="2019"></o-app-footer>
      </div>
</template>

<style>
    .white--text a {
        color: white;
    }

     #nprogress .bar {
      background: #1976d2 !important;
      height: 5px !important;
    }

</style>

<script>
    import MENU_ITEMS from "./app/menu_items";
    import ADMIN_ITEMS from "./app/admin_items";
    import OAppDrawer from "./vue-ocom/components/layout/app/OAppDrawer";
    import OAppContent from "./vue-ocom/components/layout/app/OAppContent";
    import OAppFooter from "./vue-ocom/components/layout/app/OAppFooter";


    export default {
        name: 'App',
        components: {OAppContent, OAppFooter, OAppDrawer},
        data: () => ({
            admin_items: ADMIN_ITEMS,
            items: MENU_ITEMS,
        }),
        props: {
            source: String,
        },
        created () {
            window.addEventListener('beforeunload', function (event) {
                event.preventDefault();

                event.returnValue = ''
            })
        },
    }
</script>